
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.948 1.4H2.262a.862.862 0 00-.862.862v14.476c0 .476.386.862.862.862h11.686a.862.862 0 00.861-.862V2.262a.862.862 0 00-.861-.862z","stroke":"#221B38","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M4.431 6.266h2.301M3.656 7.75l.775-1.483-.775 1.483zm3.75 0l-.674-1.483.674 1.483zM4.431 6.266l1.066-2.038a.174.174 0 01.313.009l.922 2.03h-2.3zM8.453 4h4.186M8.453 6.092h4.186","stroke":"#221B38","stroke-width":".5","stroke-linecap":"round"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.96 10.284c0-.096.078-.174.174-.174h9.942c.097 0 .175.078.175.175v5.58a.174.174 0 01-.175.175h-.125a.174.174 0 00.151-.26l-1.743-3.062a.174.174 0 00-.251-.057L8.09 14.766a.174.174 0 01-.163.02l-2.08-.804a.175.175 0 00-.167.023L3.38 15.726a.174.174 0 00.104.314h-.35a.174.174 0 01-.174-.174v-5.582zm1.715 2.268c.548 0 .993-.43.993-.96s-.445-.959-.993-.959-.993.43-.993.96.445.959.993.959z","fill":"#221B38"}})])
          )
        }
      }
    